<template>
<v-container class="pa-5">
      <v-row no-gutters justify="center">
   
       <v-form
              style="margin-top: 8%; width: 370px;"
                ref="form"
                v-model="valid"
                lazy-validation
              >
            <v-card  class="pa-2" flat>
              
              <v-card-text>
                  <p class="text-center text-primary">Reset Password</p>
                  
                   <v-text-field
                        v-model="email"
                        :rules="nameRules"
                        label="Enter email address"
                        required
                        dense
                        outlined
                        @change="check_email()"
                      ></v-text-field>
                    
                      <v-btn
                        v-if="found"
                        color="primary"
                        block
                        :loading="loading"
                        rounded
                        dense
                        @click="validate"
                      >
                       Reset Password
                      </v-btn>
                     <v-alert
                    dense
                    class="mt-4"
                    text
                   v-if="alert"
                    type="success"
                    >
                    Please check you email <strong>{{email}}</strong> for your new password!  
                    </v-alert>
                       
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                   <a href="/login" class="sm-font"> Login to my account</a>
                   <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-form>
   </v-row>
</v-container>
</template>
<script>

import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      code:"",
      alert: false,
      valid: true,
      found: false,
      loading: false,
      email: '',
      hash_data:'',
      nameRules: [
        v => !!v || 'Enter registered email'
      ]
    }),
    mounted(){
      this.PING()
    },
    created() {
     
    },
    computed:{
      HASHDATA() {
        if(this.found) {
           return this.GEN_HASH_VALUE(this.email)
        }
          return ''
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
     check_email(){
       this.$http.post("user/check_email", {email: this.email}).then(response => {
            if(!response.data.status) {
                this.VA_ALERT('error', "Email not found!")
              }
             response.data.status?this.found=true:this.found=false
              }).catch(e => {
              console.log(e.data)
          })
     },
      validate () {
        if (this.$refs.form.validate()) {
            this.ResetPass()
        }
      },
      ResetPass() {
        this.loading = true
        this.$http.post("user/reset_password", {email: this.email}).then(response => {
              if(response.data.status) {
                  this.alert = true
              }
               this.loading = false
              }).catch(e => {
              console.log(e.data)
          })
      }
    },
  }
</script>